import React from "react";
import '../../css/components/controls/HrnbCard.css'

export default function HrnbCard({
                                     className = "",
                                     title,
                                     subtitle,
                                     icon,
                                     actions,
                                     children,
                                     ...props
                                 }) {
    return (
        <div className={`hrnb-card ${className}`} {...props}>
            {(title || actions || icon || subtitle) && (
                <div className="hrnb-card__header">
                    {icon && <span className="hrnb-card__icon">{icon}</span>}
                    <div className="hrnb-card__titles">
                        {title && <div className="hrnb-card__title">{title}</div>}
                        {subtitle && <div className="hrnb-card__subtitle">{subtitle}</div>}
                    </div>
                    {actions && <div className="hrnb-card__actions">{actions}</div>}
                </div>
            )}
            <div className="hrnb-card__content">
                {children}
            </div>
        </div>
    );
}
